import UserInformation from './UserInformation.container';
export default UserInformation;
